import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxios from '../../../axios/useAxios';
import { useSelector } from 'react-redux';
import logoGoogle from '../../../styles/img/google.svg';
import tel from '../../../styles/img/tel.svg';
import inscriptionHeader from '../../../styles/img/account/inscriptionHeader.svg';
import BackButton from '../../../components/button/BackButton.jsx';
import RegisterEmail from './RegisterEmail.jsx';
import { FooterAccount } from '../../../components/footerAccount.jsx';
import { useFunnelTracking } from '../../../posthog/funnelTracking';
import { usePerformanceContext } from '../../../context/PerformanceContext.jsx';
import { useGoogleAuth } from '../../../context/GoogleAuthContext';
import {
  ACCOUNT,
  INVITATION,
  LOGIN,
  NUMBER_SCREEN,
  PROMO,
  SCAN,
  SET_ACCOUNT,
} from '../../../constants/routes';
import { isAppPWA } from '../../../utils/helper-functions.js';

const RegisterScreen = () => {
  const { prevPage, numberSreenPrevPage } = useLocation().state || '';
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { cartItems } = useSelector((state) => state.cart);
  const { isLoadingGoogleAuth, initiateGoogleLogin } = useGoogleAuth();
  const [previousNumberScreen, setPreviousNumberScreen] = useState(null);
  const refComposant = useRef();
  const { markComplete } = usePerformanceContext();
  const isPWA = isAppPWA();
  const { trackPageViewAccount } = useFunnelTracking();
  const [selectedItem, setSelectedItem] = useState(4);
  const axiosInstance = useAxios();

  useEffect(() => {
    trackPageViewAccount({
      isLoggedIn: false,
    });
  }, [trackPageViewAccount]);

  useEffect(() => {
    if (user?._id) {
      if (isPWA && !user.favoriteStore) {
        navigate(SET_ACCOUNT);
      } else {
        console.info('RegisterScreen redirecting to ACCOUNT', user);
        navigate(ACCOUNT);
      }
    }
  }, [user, isPWA, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (numberSreenPrevPage && numberSreenPrevPage === INVITATION) {
      setPreviousNumberScreen(numberSreenPrevPage);
    }
  }, [numberSreenPrevPage]);

  useEffect(() => {
    if (user?.id) {
      if (prevPage === 'invitation') {
        navigate(PROMO, { state: { prevPage: 'account' } });
        localStorage.removeItem('popupUser');
      } else if (prevPage === SCAN) {
        navigate(SCAN);
      }
    }
  }, [user, prevPage, navigate]);

  useEffect(() => {
    if (!isLoadingGoogleAuth) {
      markComplete();
    }
  }, [isLoadingGoogleAuth, markComplete]);

  const goBack = () => {
    if (previousNumberScreen === INVITATION) {
      navigate(NUMBER_SCREEN, { state: { prevPage: INVITATION } });
    } else {
      navigate(NUMBER_SCREEN);
    }
  };

  const navigateToLogin = () => {
    navigate(LOGIN);
  };

  return (
    <>
      <div
        id="page_register"
        className="w-full h-full overflow-y-scroll bg-gradient3"
      >
        <div className="page_account_body pt-10 pb-10 height_normal">
          <BackButton onClick={goBack} isWhite={false} />
          <div className="header-svg-container">
            <img
              src={inscriptionHeader}
              alt="header"
              className="header-svg"
            />
          </div>

          <button
            type="button"
            onClick={navigateToLogin}
            className="sticky w-full my-4 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            Déjà un compte ?{' '}
            <strong className="bold_blue ">Connexion</strong>
          </button>

          <div className="flex flex-col items-start justify-start w-screen h-full p-6 ">
            <div className="flex flex-col items-center justify-start w-full py-6 gap-14">
              <div className="flex items-center justify-center gap-8 space-x-4">
                <button
                  type="button"
                  className="flex items-center justify-center w-full gap-4 text-3xl font-black flex-nowrap border-none"
                  onClick={() => navigate(NUMBER_SCREEN)}
                >
                  <img src={tel} alt="telephone" />
                </button>
                <button type="button" onClick={initiateGoogleLogin} className="border-none">
                  <img
                    className="h-[50px] w-auto"
                    src={logoGoogle}
                    alt="google"
                  />
                </button>
              </div>
            </div>
            <RegisterEmail
              user={user}
              cartItems={cartItems}
              ref={refComposant}
              axiosInstance={axiosInstance}
            />
          </div>
        </div>
      </div>
      <FooterAccount
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </>
  );
};

export default RegisterScreen;

